import React, { Children, isValidElement, useCallback, useEffect, useMemo, useState } from 'react';
import { Icon, Button } from '@tcc/crate';
import styles from '../cards/cardAndPreview/cardAndPreview.css';

interface CollapseProps {
  children: React.ReactNode[];
  collapseText: string;
  expandText: string;
  testId?: string;
}

export const Collapse = ({ children, collapseText, expandText, testId = 'collapse-expand' }: CollapseProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const childrenKey = useMemo(() => Children.toArray(children)
    .map((child, index) => isValidElement(child) ? child.key ?? index : index)
    .join('|'), [children]);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((currentValue) => !currentValue);
  }, []);

  useEffect(() => {
    setIsCollapsed(true);
  }, [childrenKey]);

  return (
    <>
      {children[0]}
      {!isCollapsed && children.slice(1)}
      {children.length > 1 && (
        <Button
          className={styles.collapseBtn}
          mode="link"
          onClick={toggleCollapse}
          testId={testId}
        >
          <span>
            {isCollapsed ? (
              <Icon glyph={Icon.set.ARROW_DOWN} />
            ) : (
              <Icon glyph={Icon.set.ARROW_UP} />
            )}
          </span>
          <span>{isCollapsed ? expandText : collapseText}</span>
        </Button>
      )}
    </>
  );
}
